// extracted by mini-css-extract-plugin
export default {"wrapper":"__X2muP"};